<template>
  <div class="container container-padding">
    <h1>{{ title }}</h1>
    <div>{{ text }}</div>
    <div class="mt-4">
      <router-link to="/">Hem</router-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  title: string
  text: string
}>()
</script>

<style lang="scss" scoped>
h1 {
  color: rgb(212, 120, 103);
  font-weight: bold;
}
</style>
